import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerInterno = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: 10px;
`;

export const ContainerModal = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 1rem;
`;

export const ContainerHorario = styled.div`
    width: 504px;
    height: 348px;
`

export const Schedule = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns:  3fr 2fr 2fr 1fr 1fr;
    margin: 10px 0px;
    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
    padding: 6px 10px;
    border-radius: 6px;
    
`;

export const ScheduleField = styled.div`
    color: ${({ theme }) => theme.colors.text};
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    width: 100%;
    height: 100%;
    padding: 0 8px;
    
    color: ${({ theme }) => theme.colors.text};
`;

export const ScheduleStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.status ? '#03b252' : '#e33c30'};
  color: #fff;
  border-radius: 6px;
  font-size: 11px;
`
